<template>
  <w-select class="mt4" :items="d_tahun" label="Tahun"  v-model="carian.tahun" @input="getData(2)"/><br>
  <div class="dashboard1">
    <div class="cardse" v-for="card in cards2" :key="card.id" :class="getCardClass(card.id)" @click="item(card.item)">
      <div class="card-icon">
        <h2>{{ card.title }}</h2>
      </div>
      <div class="card-info1">
        <p>{{ card.count }}</p>
      </div>
    </div>
  </div>
  <br>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  name: "SeSttp",
  components: {
        GChart
  },
  props: {
    auth: [Array, Object],
  },
  data() {
    return {
      cards: [
        { id: 1, title: 'Jumlah Pengguna', count: 1500, icon: 'fas fa-users' },
        { id: 2, title: 'Pengguna Aktif', count: 1200, icon: 'fas fa-user-check' },
        { id: 3, title: 'Pengguna Baru', count: 300, icon: 'fas fa-user-plus' },
        { id: 4, title: 'Pengguna Baru', count: 300, icon: 'fas fa-user-plus' },
        { id: 5, title: 'Pengguna Baru', count: 300, icon: 'fas fa-user-plus' },
      ],
      cards2:[],
      d_tahun: [],
      carian: { tahun: "" },
    }
  },
  methods:{
    getData(item){
        if(item==1){
          var today = new Date();
          this.carian.tahun = today.getFullYear(); 
        }
        this.$zcomm.get(this.api_service + 'dashboard/permohonan-sttp/1?tahun='+this.carian.tahun, {}).then(res => {
          this.cards2 = res
        })
    },
    getTahun(){
      this.$zcomm.get(this.api_service + 'lookup/tahun', {}).then(res => {
        this.d_tahun = res
      })
    },
    item(id){
      window.location.href = window.route('se.permohonan.sttp.index')+'?status='+id;
    },
    getCardClass(id) {
      return `cardse-${id}`;
    },
  },
      
  mounted() {
    this.getData(1)
    this.getTahun();
  }
}
      

</script>  
<style type="text/css">
  .dashboard1 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  padding: 20px;
  background-color: #f5f5f5;
}

.cardse {
  background: linear-gradient(135deg, #42a5f5, #478ed1);
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
}

.cardse:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}

.card-icon {
  font-size: 60px;
  margin-bottom: 15px;
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.3s;
}

.cardse:hover .card-icon {
  color: #fff;
}

.card-info2 h2 {
  margin: 0;
  font-size: 18px;
  margin-right: 95px;
  font-weight: bold;
  color: #f1f1f1;
  letter-spacing: 1px;
}

.card-info2 p {
  margin-top: 8px;
  margin-right: 95px;
  font-size: 60px;
  font-weight: bold;
  color: #fff;
}
.cardse-19 {
    background: linear-gradient(135deg, rgb(245 163 49 / 8%), rgb(245 162 49)), url(/images/draf.png) center / cover no-repeat;
}
.cardse-16 {
    background:linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(218 197 6)), url(/images/p-mohon.png) center / cover no-repeat;
}
.cardse-22 {
    background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(57 178 44)), url(/images/p-lulus.png) center / cover no-repeat;
}
.cardse-21 {
    background:linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(175 20 20)), url(/images/p-tolak.png) center / cover no-repeat;
}


</style>
